// Commission schedule — single source of truth (matches /process page table)
export const COMMISSION_TIERS = {
  crude: {
    key: "crude", category: "Energy",
    label: "Crude Oil — WTI / Brent",
    trial: "136,000 MT", min: "$0.07 / MT", max: "$0.37 / MT",
    barrel_note: "≈ $0.01–$0.05 per barrel",
  },
  refined: {
    key: "refined", category: "Energy",
    label: "Refined Oil — EN 590 / Jet A-1",
    trial: "50,000 MT", min: "$1.00 / MT", max: "$2.50 / MT",
  },
  sugar: {
    key: "sugar", category: "Soft",
    label: "Sugar — ICUMSA 45",
    trial: "12,500 MT", min: "$1.50 / MT", max: "$3.00 / MT",
  },
  coffee: {
    key: "coffee", category: "Soft",
    label: "Coffee — Arabica / Robusta",
    trial: "21 MT", min: "$5.00 / MT", max: "$10.00 / MT",
  },
};

export const ENERGY_TIERS = [COMMISSION_TIERS.crude, COMMISSION_TIERS.refined];
export const SOFT_TIERS = [COMMISSION_TIERS.sugar, COMMISSION_TIERS.coffee];

/**
 * Map a commodity string from the deal record to its commission tier.
 * Matches the same enums used in DealIntake.jsx.
 */
export function commissionFor(commodity) {
  if (!commodity) return null;
  const c = commodity.toLowerCase();
  if (c.includes("crude")) return COMMISSION_TIERS.crude;
  if (
    c.includes("gasoil") || c.includes("jet") ||
    c.includes("gasoline") || c.includes("refined") ||
    c.includes("en 590") || c.includes("en590")
  ) return COMMISSION_TIERS.refined;
  if (c.includes("sugar") || c.includes("icumsa")) return COMMISSION_TIERS.sugar;
  if (c.includes("coffee")) return COMMISSION_TIERS.coffee;
  return null;
}
